import { WEB_SERVICES } from "../../../../bitSagas/webServices";
import { USER_TYPE } from '../../../../bitConstants/constants';
import { WEBSERVICE_ERRORS } from '../../../errorCatalog';

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    common: {
      BUSINESS_ERRORS: {
        INCOMPATIBLE_CLIENT_PRODUCTS: errorToPrint.INCOMPATIBLE_PRODUCT,
        AUTO_RENEWAL_FAIL: errorToPrint.AUTO_RENEWAL_FAIL,
      },
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
        },
      },
    },
    [`user_${USER_TYPE.OPEN}`]: {

    },
  }

  return handledErrors;
}
